module.exports = __webpack_public_path__ + "static/img/9.b6b7c7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/zh/9.png
// module id = ogzS
// module chunks = 0